import { Typography } from '@mui/material'
import { hasKnownCvDates, METROPOLE_CV_NOTE } from '../utils/metropolitanCv'
import { FormType } from '../utils/sharedTypes'

const MetropolitanCvNote = ({ form }: { form: FormType }) => {
  if (
    !hasKnownCvDates({
      product: form.data.product,
      products: form.data.products,
      session: form.data.session,
      sessions: form.sessions,
    })
  ) {
    return null
  }
  return (
    <Typography variant="body2" sx={{ mt: 1 }}>
      {METROPOLE_CV_NOTE}
    </Typography>
  )
}

export default MetropolitanCvNote
